import { ScopedPermissionInfo } from '@bn/openapi/core';

export class ScopedApiKeysUtils {
  /**
   * A product can be scoped to resource IDs unless every one of its permission levels is
   * wildcard-only. `WildcardOnly` is OPTIONAL, so absent metadata must read as "scopable" —
   * testing `=== false` instead classified `{}` as wildcard-only and hid the resource controls,
   * leaving the user able to create only an all-resources key.
   */
  static isResourceSearchable(levelsMap: { [key: string]: ScopedPermissionInfo } = {}): boolean {
    return Object.values(levelsMap).some((info) => info?.WildcardOnly !== true);
  }

  // 'EdgeScript' → 'Edge Script'
  public static formatProductLabel(product: string): string {
    const spaced = product.replace(/([a-z])([A-Z])/g, '$1 $2');

    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }
}
